import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { environment } from '@/shared/configs';

export const keycloakInitOptions: KeycloakInitOptions  = {
    onLoad: 'login-required',
    checkLoginIframe: false,
    silentCheckSsoFallback: false,
}

export const keycloak = new Keycloak({
    url: environment.VITE_KEYCLOAK_API,
    realm: environment.VITE_KEYCLOAK_REALM,
    clientId: environment.VITE_KEYCLOAK_CLIENT_ID,
});

export const LOGOUT_SYNC_KEY = 'keycloak_logout_sync'
export const TOKEN_AUTO_UPDATE_INTERCEPTOR_NAME = 'auth-token-auto-update'
export const AUTH_TOKEN_INTERCEPTOR_NAME = 'auth-token'
export const KEYCLOAK_UPDATE_TOKEN_TIMEOUT_SEC = 80
export const KEYCLOAK_UPDATE_TOKEN_CHECK = 300000
